// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1dn-3","alertIcon":"ConfirmModal_alertIcon__3GpX4"};